﻿'use strict';
var _ = require('lodash');


// @ngInject 
var unsubscribeCtrl = function ($scope, $location, subscriberSvc) {

    //Initial state
    $scope.decision = "none";

    $scope.$watch(function () {
        return subscriberSvc.subscriber;
    }, function (subscriber) {
        $scope.subscriber = subscriber;

        //redirect to invalid page if no npeId
        if ($scope.subscriber.status === 'invalid') {
            $location.url('/invalid');
            return;
        }
    });

    // Retrieve user and redirect to unsubscribe page if subscribed
    subscriberSvc.getuser().then(function (subscriber) {

        //redirect to invalid page if npeId not recognised
        if (subscriber.status === 'invalid') {
            $location.url('/invalid');
            return;
        }

        //console.log(subscriber, 'getuser');
        if (subscriber.status === 'subscribed') {
            $scope.decision = "resubscribed-already";
        }
    });

    $scope.resubscribe = function () {
        subscriberSvc.resubscribe().then(function() {
            $scope.decision = "resubscribed";
        });
    }

    $scope.cancelled = function () {
        $scope.decision = "cancelled";
    }

    $scope.unsubscribe = function () {
        $location.path('/unsubscribe');
    }

};


module.exports = unsubscribeCtrl;

